import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import Icon from '../Icon/Icon';
import Button from '../Button/Button';

const NavigationItemButton = styled(Button)`
  text-align: left;
  font-family: ${props => props.theme.fonts.fontfaceBold};
  text-transform: uppercase;
  font-size: ${props => props.theme.fonts.sizeSmall};
  display: flex;
  align-items: center;
  padding: 12px 30px;
  transition: padding .2s ease-in-out;

  svg {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  ${props =>
    props.active &&
    css`
      padding: 20px 30px;
      background: ${props => props.theme.colors.darkgray};
    `}
  ${props =>
    props.blue &&
    css`
      color: ${props => props.theme.colors.primary};
    `} 
  ${props =>
    props.textcenter &&
    css`
      justify-content: center;
      text-align: center !important;
    `};

  ${props =>
    props.bigBtn &&
    css`
      padding: 20px 30px;
    `}
`;

function NavigationItem({ icon, children = null, ...rest }) {
  return (
    <NavigationItemButton full {...rest}>
      {icon && <Icon id={icon} />}
      {children}
    </NavigationItemButton>
  );
}

NavigationItem.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node
};

export default NavigationItem;
